import { readNestedStockQuantity } from './stockKeys';

/** Storefront cart UI cap (matches bag page). */
export const CART_QTY_MAX = 10;

function isDefaultVariant(value) {
  if (value == null || value === '') return true;
  const s = String(value).trim().toLowerCase();
  return s === 'default' || s === 'default size' || s === 'as image';
}

/**
 * Available units for one cart line from an embedded product.stock object.
 * Returns null if product/stock missing (caller may hit stock/check API).
 */
export function resolveAvailableStockFromProduct(product, rawColor, rawSize) {
  if (!product?.stock || typeof product.stock !== 'object') return null;

  const color = rawColor != null && rawColor !== '' ? rawColor : 'default';
  const size = rawSize != null && rawSize !== '' ? rawSize : 'default';

  if (product.category === 'unstitched') {
    for (const [ck, qty] of Object.entries(product.stock)) {
      if (String(ck).toLowerCase() === String(color).toLowerCase()) {
        const n = parseInt(qty, 10);
        return Number.isNaN(n) ? 0 : Math.max(0, n);
      }
    }
    const direct = product.stock[color];
    if (typeof direct === 'number') return Math.max(0, direct);
  }

  const colorKey = isDefaultVariant(color) ? 'default' : color;
  const sizeKey = isDefaultVariant(size) ? 'default' : size;

  let qty = readNestedStockQuantity(product.stock, colorKey, sizeKey);
  if (qty <= 0 && (colorKey !== color || sizeKey !== size)) {
    qty = readNestedStockQuantity(product.stock, color, size);
  }
  return qty;
}

export function purchasableMax(stockQty) {
  if (stockQty == null || stockQty === '') return CART_QTY_MAX;
  const n = Math.max(0, parseInt(stockQty, 10) || 0);
  if (n === 0) return 0;
  return Math.min(n, CART_QTY_MAX);
}

export function findCatalogProduct(products, productId) {
  if (!productId || !Array.isArray(products)) return null;
  const id = String(productId);
  return (
    products.find((p) => String(p._id ?? p.id) === id) ||
    null
  );
}
